import { Box } from '@material-ui/core'
import { Skeleton } from 'antd'
import React, { memo } from 'react'

/**
 * LoadingCardSkeletons component renders a skeleton loader for track change cards.
 * It displays a specified number of skeleton cards with a consistent style.
 * @param {number} [props.level=3] - The number of skeleton cards to display.
 * @returns {JSX.Element} The rendered loading card skeletons.
 */
export const LoadingCardSkeletons = memo<{ level?: number }>(
    ({ level = 3 }) => {
        return (
            <Box
                padding={2}
                display="flex"
                flexDirection="column"
                marginTop={0}
            >
                {Array.from({ length: level }).map((_, i) => (
                    <Box
                        key={i}
                        padding={1}
                        marginBottom={2}
                        display="flex"
                        flexDirection="column"
                        border="1px solid #e0e0e0"
                        borderRadius="8px"
                        boxShadow="0 2px 4px rgba(0, 0, 0, 0.1)"
                        height={94}
                        width={280}
                        sx={{ bgcolor: '#fff' }}
                    >
                        <Skeleton
                            avatar
                            active
                            title={{ width: '100%' }}
                            paragraph={{
                                rows: 1,
                                style: {
                                    height: '20px',
                                },
                            }}
                        />
                    </Box>
                ))}
            </Box>
        )
    }
)
